<template>
  <div class="row">
    <div class ="col-md-6 py-0 mx-0">
      <div>
        <i class="fa fa-arrows" aria-hidden="true"></i>
        <strong>Drag the blue dot to adjust the latitude and longitude</strong>
      </div>
      <div class="mb-2" id="map-edit-loc-2"></div>
    </div>
    <div class ="col-md-6">
      <div class ="col-md-12 px-0 mx-0">
        <div class="form-group">
          <label for="latitude">Latitude</label>
          <input :class="{'input form-control': true, 'is-invalid form-control': hasLatError }" class="form-control" ref="latitude" :value="latitude" @input="updateMap()">
          <span class="help is-invalid" v-show="hasLatError">You've entered an invalid latitude.</span>
        </div>
      </div>
      <div class ="col-md-12 px-0 mx-0">
          <label for="longitude">Longitude</label>
          <input :class="{'input form-control': true, 'is-invalid form-control': hasLongError }"  class="form-control" ref="longitude" :value="longitude" @input="updateMap()">
          <span v-show="hasLongError" class="help is-invalid">You've entered an invalid longitude.</span>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import geomixin from './geo-mixin.js'

mapboxgl.accessToken = 'pk.eyJ1IjoiZ2V0bG9jYWwiLCJhIjoiY2o1d2wzZjl5MGZ0azJ3cDdmamQxbndoaiJ9.O_61tTWZTGI_v3BvhBls1Q'

export default {
  name: 'MapBoxLatLong2',
  mixins: [geomixin],
  props: {
    'has-errors': Boolean,
    'has-lat-error': Boolean,
    'has-long-error': Boolean,
    'latitude': 0.0,
    'longitude': 0.0
  },
  data: function () {
    return {
      map: {},
      geojson: {
        'type': 'FeatureCollection',
        'features': [{
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [0, 0]
          }
        }]
      },
      isDragging: false,
      isCursorOverPoint: false
    }
  },
  mounted: function () {
    this.initMap()
  },
  watch: {
    latitude: function (latitude) {
      this.addPointToMap(latitude, this.longitude)
      this.flyToLocation(latitude, this.longitude)
    },
    longitude: function (longitude) {
      this.addPointToMap(this.latitude, longitude)
      this.flyToLocation(this.latitude, longitude)
    }
  },
  methods: {
    initMap: function () {
      setTimeout(() => {
        this.map = new mapboxgl.Map({
          container: 'map-edit-loc-2',
          style: 'mapbox://styles/mapbox/bright-v9',
          zoom: 16

        })

        this.map.on('load', () => {
          this.addPointToMap(this.latitude, this.longitude)
          this.flyToLocation(this.latitude, this.longitude)
          this.initPinDrag()
        })
      }, 30)
    },
    updateMap: function () {
      this.$emit('latitude', this.$refs.latitude.value)
      this.$emit('longitude', this.$refs.longitude.value)

      if (this.map) {
        this.addPointToMap(this.$refs.latitude.value, this.$refs.longitude.value)
        this.flyToLocation(this.$refs.latitude.value, this.$refs.longitude.value)
      }
    },
    addPointToMap: function (lat, lng) {
      const center = this.findCenter(lat, lng)
      if (!this.isValidLatLong(lat, lng)) {
        return
      }

      if (this.map.getLayer('marker')) {
        this.map.removeLayer('marker')
      }
      if (this.map.getSource('marker')) {
        this.map.removeSource('marker')
      }

      if (this.map.getLayer('point')) {
        this.map.removeLayer('point')
      }

      if (this.map.getSource('point')) {
        this.map.removeSource('point')
      }
      this.geojson.features[0].geometry.coordinates = center

      this.map.addSource('point', {
        'type': 'geojson',
        'data': this.geojson
      })

      this.map.addLayer({
        'id': 'point',
        'type': 'circle',
        'source': 'point',
        'paint': {
          'circle-radius': 10,
          'circle-color': '#3887be'
        }
      })
    },
    flyToLocation: function (lat, lng) {
      if (this.isValidLatLong(lat, lng)) {
        this.map.setCenter(this.findCenter(lat, lng))
      }
    },
    findCenter: function (lat, lng) {
      return [lng, lat].map(e => {
        return parseFloat(e)
      })
    },
    initPinDrag: function () {
      // When the cursor enters a feature in the point layer, prepare for dragging.
      var canvas = this.map.getCanvasContainer()
      var self = this
      this.map.on('mouseenter', 'point', function () {
        self.map.setPaintProperty('point', 'circle-color', '#3bb2d0')
        canvas.style.cursor = 'move'
        self.isCursorOverPoint = true
        self.map.dragPan.disable()
      })

      this.map.on('mouseleave', 'point', function () {
        self.map.setPaintProperty('point', 'circle-color', '#3887be')
        canvas.style.cursor = ''
        self.isCursorOverPoint = false
        self.map.dragPan.enable()
      })

      this.map.on('mousedown', function () {
        self.mouseDown()
      })
    },
    onMove: function (e) {
      if (!this.isDragging) return
      var coords = e.lngLat
      // Set a UI indicator for dragging.
      var canvas = this.map.getCanvasContainer()

      canvas.style.cursor = 'grabbing'

      this.geojson.features[0].geometry.coordinates = [coords.lng, coords.lat]
      this.map.getSource('point').setData(this.geojson)
    },
    mouseDown: function () {
      if (!this.isCursorOverPoint) return

      this.isDragging = true
      var canvas = this.map.getCanvasContainer()
      // Set a cursor indicator
      canvas.style.cursor = 'grab'

      // Mouse events
      this.map.on('mousemove', this.onMove)
      this.map.once('mouseup', this.onUp)
    },
    onUp: function (e) {
      if (!this.isDragging) return
      var coords = e.lngLat
      var canvas = this.map.getCanvasContainer()

      this.$emit('update:longitude', coords.lng)
      this.$emit('update:latitude', coords.lat)
      this.$refs.latitude.value = coords.lat
      this.$refs.longitude.value = coords.lng
      canvas.style.cursor = ''
      this.isDragging = false

      // Unbind mouse events
      this.map.off('mousemove', this.onMove)
      // this.flyToLocation(newgeo)
    }
  }
}
</script>
<style type="text/css">
#map-edit-loc-2 {
  width: 100%;
  /*position:absolute; top:0; bottom:0;*/
  height: 160px;
}
.mapbox-img{
  max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// mapbox-latlong-2.vue?0eca2908